export default __webpack_public_path__ + "static/media/greenCheckMark.8e80e025.webp";